import { COLOR_VALUES } from "shared/config/colors";
import HStack from "shared/components/layout/stack/HStack";
import React from "react";
import Table from "shared/components/data-display/tables/Table";
import TertiaryButton from "shared/components/inputs/button/TertiaryButton";
import { getCellWidthInPercent } from "features/admin/clients/ClientsTable";
import useClientContactLeads from "features/admin/clients/single/useClientContactLeads";

const Table_Width = 640;

const columns = [
    {
        headCellProps: {
            text: "ID",
            width: getCellWidthInPercent(72, Table_Width),
        },

        getBodyCellProps: (cell) => ({
            text: cell.value,
        }),
        accessor: "userId",
    },
    {
        headCellProps: {
            text: "Name",
            width: getCellWidthInPercent(288),
        },
        getBodyCellProps: (cell) => ({
            text: cell.value ?? "-",
        }),
        accessor: "fullName",
    },
    {
        headCellProps: {
            text: "Department",
            width: getCellWidthInPercent(188, Table_Width),
        },
        getBodyCellProps: (cell) => ({
            text: cell.value ?? "-",
        }),
        accessor: "department",
    },
    {
        headCellProps: {
            text: "Office",
            width: getCellWidthInPercent(60, Table_Width),
        },
        getBodyCellProps: (cell) => ({
            text: cell.value ?? "-",
        }),
        accessor: "officeAcronymous",
    },
    {
        headCellProps: {
            width: getCellWidthInPercent(100),
        },
        accessor: "Active",
        disableSortBy: true,
        getBodyCellProps: (cell) => ({
            shownByRowHover: true,
            actionIcon: "edit",
            actionProps: {
                to: `?action=editContactLead&id=${cell.row.original.userId}`,
                replace: true,
                "aria-label": "Edit",
            },
        }),
    },
];

const tableCTAProps = {
    leadingIcon: "expand",
    label: "Add",
    to: "?action=addContactLead",
    replace: true,
};

const getRowProps = (row) => ({
    style: {
        background: row.values.Active === false ? COLOR_VALUES.Gray_9 : "",
    },
});

const ClientContactLeadsTable = () => {
    const { clientContactLeads } = useClientContactLeads();

    if (clientContactLeads.isLoading) {
        return <>Loading...</>;
    }

    if (clientContactLeads.isError) {
        return <>Error</>;
    }

    return (
        <>
            <HStack align="end" justify="end">
                <TertiaryButton {...tableCTAProps} />
            </HStack>
            <Table
                columns={columns}
                data={clientContactLeads.data}
                emptyActionProps={tableCTAProps}
                emptyMessageTableTitle={"Contact Leads"}
                getRowProps={getRowProps}
            />
        </>
    );
};

export default React.memo(ClientContactLeadsTable);
